import Banner from "../sections/Banner";

function Nav() {
  return (
    <>
      <Banner />
      {/* <nav className="navbar">
        <Logo />
        <a to="/about" className="navbar-item">
          Services
        </a>
        <a to="/about" className="navbar-item">
          Work
        </a>
        <a to="/about" className="navbar-item badge">
          Contact
        </a>
      </nav> */}
    </>
  );
}

export default Nav;
